import $ from 'jquery'
import slick from 'slick-carousel'
import LazyLoad from "vanilla-lazyload"
import { gsap } from "gsap"
import { ScrollToPlugin } from 'gsap/all'
import ScrollMagic from 'scrollmagic'
import ModalVideo from 'modal-video'
import 'jquery-modal'

/* SETUP SLICK
  ----------------------------- */
export const setupSlideshow = (el, type = 'basic', slidesNumber = 1) => {
  const $el = $(el);
  const opts = {
    basic: {
      autoplay: false,
      dots: true,
      arrows: true,
      infinite: true,
    }
  }

  $el.slick(opts[type])
}



export const facetAccordion = () =>  {
    $(document).on('facetwp-loaded', function() {
        $('.facetwp-depth').show();
        $('.facetwp-checkbox.checked').each(function() {
            $(this).parents('.facetwp-depth').show();
            $(this).next('.facetwp-depth').show();
        });
    });
}


/* SEARCH SHOW
----------------------------- */
export const searchShow = () => {
  const content = $('.header--search')
  const search = $('.button-search')
  const close = $('.header--search .button-close')


  search.on('click', function() {
    content.addClass('show');
    return false;
  })

  close.on('click', function() {
    content.removeClass('show');
    return false;
  })
}


/* GET CURRENT IMAGE URL
  ----------------------------- */
  export const imgUrl = () => {
    console.log('init')

    $('.download_image').on('click', function() {
      var currentImg = $('.section--hero .slick-slider .slick-current img').attr('src');
        $(this).attr('href', currentImg)
    })

  }

/* SCROLL TO TOP
  ----------------------------- */
export const scrollTop = () => {
  let lastScrollTop
  $('.back-button').hide()
  $(window).scroll(function(event){
     var st = $(this).scrollTop();
     if (st > lastScrollTop && st > 300){
         $('.back-button').show()
     } else {
        $('.back-button').hide()
     }
     lastScrollTop = st;
  });
}


/* LAZY LOAD
  ----------------------------- */
export const lazyLoad = () => {
  const lazyLoadInstance = new LazyLoad({
    elements_selector: ".lazy",
    data_src: "lazy",
  })
}

/* SMOOTH SCROLL
  ----------------------------- */
export const smoothScroll = () => {
  $('a[href*="#"]:not([href="#"]):not([href="#top"])').click(function(e) {
    const target = $(this.hash)
    if (target.length > 1) e.preventDefault()
    // TweenLite.to(window, 1, { scrollTo: target.offset().top-100 })
    $('html, body').animate({ scrollTop: target.offset().top-150 }, 1000)
  })

  $("a[href='#top']").click(function(e) {
    e.preventDefault()
    // TweenLite.to(window, .8, { scrollTo: 0 })
    $('html, body').animate({ scrollTop: 0 }, 800)
  })
}

/* HEADER ANIMATION
  ----------------------------- */
export const menuOverlay = () => {
  const toggle = $('.header__toggle')
  const bar = $('.header__toggle .bar')
  const overlay = $('.header--offcanvas, .header__inner, .content-area, body')
  const link = $('.header--offcanvas a');
  const header = $('.header--main');

  toggle.on('click', function () {
    overlay.toggleClass('open')
    bar.toggleClass('animate')
    toggle.toggleClass('open')
  })

  link.on('click', function () {
    overlay.removeClass('open')
    bar.removeClass('animate')
    toggle.removeClass('open')
  })

  window.onresize = () => {
    overlay.removeClass('open')
    bar.removeClass('animate')
    toggle.removeClass('open')
  }

  $(window).scroll(function(e) {
    $(document).scrollTop() > 200 ?
      header.addClass('sticky') :
      header.removeClass('sticky')

    this.oldScroll > this.scrollY ?
      header.addClass('sticky-show').removeClass('sticky-hide') :
      header.addClass('sticky-hide').removeClass('sticky-show')
    this.oldScroll = this.scrollY
  })
}

/* SETUP MODALVIDEO
  ----------------------------- */
export const setupModalVideo = () => {
  if ($('.js-modal-btn').length > 0 || $('.js-modal-btn-vimeo').length > 0) {
    new ModalVideo('.js-modal-btn')
    new ModalVideo('.js-modal-btn-vimeo', { channel: 'vimeo' })
  }
}



// WEBPACK FOOTER //
// ./src/js/functions.js